import { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'

import { GetSalesTeamListInput, ISalesTeam } from '../typings'
import { getSalesTeamList } from '@user/store/salesTeam/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const useGetSalesTeamListOnMount = (props?: GetSalesTeamListInput) => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(
          getSalesTeamList({
            includeTeamsByBranchId: props?.includeTeamsByBranchId,
            includeUsers: props?.includeUsers,
            checkUsersCount: props?.checkUsersCount,
          }),
        )

        if (mounted) {
          unwrapResult(result)
          setStatus('success')
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [
    dispatch,
    props?.includeTeamsByBranchId,
    props?.includeUsers,
    props?.checkUsersCount,
  ])

  return status
}

export const useGetSalesTeamList = (props?: GetSalesTeamListInput) => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )
  const [salesTeams, setSalesTeams] = useState<ISalesTeam[]>([])

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(
          getSalesTeamList({
            includeTeamsByBranchId: props?.includeTeamsByBranchId,
            includeUsers: props?.includeUsers,
          }),
        )

        if (mounted) {
          unwrapResult(result)
          setSalesTeams(unwrapResult(result))
          setStatus('success')
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, props?.includeTeamsByBranchId, props?.includeUsers])

  return { salesTeams, status }
}
